type GetVehicleModelSelectDisabledStateParams = {
  hasVehicleModelFamilies: boolean;
  hasVehicleModels: boolean;
};

export function getVehicleModelSelectDisabledState(
  params: GetVehicleModelSelectDisabledStateParams
) {
  return {
    // Keep both fields editable when a legacy record already contains both selections.
    isModelFamilySelectDisabled: params.hasVehicleModels && !params.hasVehicleModelFamilies,
    isModelSelectDisabled: params.hasVehicleModelFamilies && !params.hasVehicleModels,
  };
}
